module.exports = __webpack_public_path__ + "img/xiaoliebiao.e0808d2f.png";